<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: 0px"></el-header>
        <el-mian style="padding-bottom: 20px; ">
            <div class="custom-title flex items-center md:h-[40px]">
                <span>環境設定</span>
            </div>

            <div class="h-[calc(100vh-122px)] md:h-[calc(100vh-112px)] overflow-y-auto">
                <!-- 輸送用パラメータ設定 -->
                <!-- 定期設定 -->
                <div class="m-4 p-4" style="border: 2px solid #d1d5db; border-radius: 10px" v-loading="loading1">
                    <div class="flex flex-col md:flex-row h-[40px]">メール通知設定：</div>

                    <el-form :model="emailSettings" :rules="emailRules" ref="emailFormRef" label-width="auto">
                        <div class="hidden md:block md:w-[680px]">
                            <el-form-item label="メールアカウント：" prop="emailAccount">
                                <el-input v-model="emailSettings.emailAccount" autocomplete="off"
                                    placeholder="メールアカウントを入力してください" />
                            </el-form-item>

                            <el-form-item label="メールパスワード：" prop="emailPassword">
                                <el-input v-model="emailSettings.emailPassword" autocomplete="off"
                                    placeholder="メールパスワードを入力してください" />
                            </el-form-item>


                            <el-form-item label="メールサーバーURL：" prop="emailServerUrl">
                                <el-input v-model="emailSettings.emailServerUrl" autocomplete="off"
                                    placeholder="メールサーバーURLを入力してください" />
                            </el-form-item>

                            <el-form-item label="メールサーバーポート：" prop="emailServerPort">
                                <el-input v-model="emailSettings.emailServerPort" :min="1" :max="65535" autocomplete="off"
                                    placeholder="メールサーバーポートを入力してください" />
                            </el-form-item>

                            <el-form-item label="送信者：" prop="emailSender">
                                <el-input v-model="emailSettings.emailSender" autocomplete="off"
                                    placeholder="送信者を入力してください" />
                            </el-form-item>

                            <el-form-item label="タイトル：" prop="emailSubject">
                                <el-input v-model="emailSettings.emailSubject" autocomplete="off"
                                    placeholder="メールタイトルを入力してください" />
                            </el-form-item>

                            <el-form-item label="内容：" prop="emailText">
                                <el-input v-model="emailSettings.emailText" autocomplete="off" type="textarea" autosize
                                    placeholder="メール内容を入力してください" />
                            </el-form-item>
                            <!-- <el-form-item label="受信者：" prop="emailReceiver">
                                <el-input v-model="emailSettings.emailReceiver" autocomplete="off"
                                    placeholder="受信者を入力してください" />
                            </el-form-item> -->
                        </div>

                        <div class="w-full md:hidden">
                            <el-form-item prop="emailAccount">
                                <el-input v-model="emailSettings.emailAccount" autocomplete="off"
                                    placeholder="メールアカウントを入力してください" />
                            </el-form-item>

                            <el-form-item prop="emailPassword">
                                <el-input v-model="emailSettings.emailPassword" autocomplete="off"
                                    placeholder="メールパスワードを入力してください" />
                            </el-form-item>


                            <el-form-item prop="emailServerUrl">
                                <el-input v-model="emailSettings.emailServerUrl" autocomplete="off"
                                    placeholder="メールサーバーURLを入力してください" />
                            </el-form-item>

                            <el-form-item prop="emailServerPort">
                                <el-input v-model="emailSettings.emailServerPort" :min="1" :max="65535" autocomplete="off"
                                    placeholder="メールサーバーポートを入力してください" />
                            </el-form-item>

                            <el-form-item prop="emailSender">
                                <el-input v-model="emailSettings.emailSender" autocomplete="off"
                                    placeholder="送信者を入力してください" />
                            </el-form-item>

                            <el-form-item prop="emailSubject">
                                <el-input v-model="emailSettings.emailSubject" autocomplete="off"
                                    placeholder="メールタイトルを入力してください" />
                            </el-form-item>

                            <el-form-item prop="emailText">
                                <el-input v-model="emailSettings.emailText" autocomplete="off" type="textarea" autosize
                                    placeholder="メール内容を入力してください" />
                            </el-form-item>
                            <!-- <el-form-item prop="emailReceiver">
                                <el-input v-model="emailSettings.emailReceiver" autocomplete="off"
                                    placeholder="受信者を入力してください" />
                            </el-form-item> -->
                        </div>
                    </el-form>
                    <!-- メール保存　-->
                    <div class="flex flex-col col-span-1 justify-start items-start">
                        <el-button type="info" @click="handleSaveEmailButton(emailFormRef)">保存</el-button>
                        <span class="text-gray-900 text-sm">※メール関連設定保存</span>
                    </div>
                </div>

                <div class="m-4 p-4" style="border: 2px solid #d1d5db; border-radius: 10px" v-loading="loading2">
                    <div class="flex flex-col md:flex-row h-[40px]">アラートメッセージ設定：</div>
                    <el-form :model="notificationSettings" :rules="notificationRules" ref="notificationFormRef" label-width="auto">
                        <div class="hidden md:block md:w-[680px]">
                            <el-form-item label="タイトル：" prop="notificationSubject">
                                <el-input v-model="notificationSettings.notificationSubject" autocomplete="off"
                                    placeholder="アラートタイトルを入力してください" />
                            </el-form-item>

                            <el-form-item label="内容：" prop="notificationText">
                                <el-input v-model="notificationSettings.notificationText" autocomplete="off" type="textarea" autosize
                                    placeholder="アラート内容を入力してください" />
                            </el-form-item>
                        </div>
                        <div class="w-full md:hidden">
                            <el-form-item prop="notificationSubject">
                                <el-input v-model="notificationSettings.notificationSubject" autocomplete="off"
                                    placeholder="アラートタイトルを入力してください" />
                            </el-form-item>

                            <el-form-item prop="notificationText">
                                <el-input v-model="notificationSettings.notificationText" autocomplete="off" type="textarea" autosize
                                    placeholder="アラート内容を入力してください" />
                            </el-form-item>
                        </div>
                    </el-form>
                    <!-- アラートメッセージ保存　-->
                    <div class="flex flex-col col-span-1 justify-start items-start">
                        <el-button type="info" @click="handleSaveNotificationButton(notificationFormRef)">保存</el-button>
                        <span class="text-gray-900 text-sm">※アラートメッセージ関連設定保存</span>
                    </div>
                </div>

                <div class="m-4 p-4" style="border: 2px solid #d1d5db; border-radius: 10px" v-loading="loading4">
                    <div class="flex flex-col md:flex-row h-[40px]">JANCODE設定：</div>
                    <el-form :model="jancodeSettings" :rules="jancodeRules" ref="jancodeFormRef" label-width="auto">
                        <div class="hidden md:block md:w-[680px]">
                            <template v-for="(key, index) in Object.keys(jancodeSettings)" :key="index">
                                <el-form-item v-if="showJancodeSettings[index]"
                                    :label="index === 0 ? 'AppId' : '\u00A0'" :prop="key">
                                    <div class="flex flex-grow items-center">
                                        <el-input v-model="jancodeSettings[key]" autocomplete="off"
                                            placeholder="AppIdを入力してください" />

                                        <span class="ml-4 w-12"> {{ jancodeCount[`count${index}`] }} </span>

                                        <el-button v-if="showJancodeSettings.filter(value => value === true).length > 1" class="ml-4" @click="handleDelJancodeButton(index)" circle>
                                            <el-icon>
                                                <Minus />
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </el-form-item>
                            </template>
                        </div>

                        <div class="w-full md:hidden">
                            <template v-for="(key, index) in Object.keys(jancodeSettings)" :key="index">
                                <el-form-item v-if="showJancodeSettings[index]" :prop="key">
                                    <div class="flex flex-grow items-center">
                                        <el-input v-model="jancodeSettings[key]" autocomplete="off"
                                            placeholder="AppIdを入力してください" />

                                        <span class="ml-4 w-12"> {{ jancodeCount[`count${index}`] }} </span>

                                        <el-button v-if="showJancodeSettings.filter(value => value === true).length > 1" class="ml-4" @click="handleDelJancodeButton(index)" circle>
                                            <el-icon>
                                                <Minus />
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </el-form-item>
                            </template>
                        </div>
                    </el-form>

                    <el-link v-if="showJancodeSettings.filter(value => value === true).length < 10" type="primary" class="mb-4" @click="handleAddJancodeButton">
                        AppId追加
                    </el-link>

                    <!-- JANCODE保存　-->
                    <div class="flex flex-col col-span-1 justify-start items-start">
                        <el-button type="info" @click="handleSaveJancodeButton(jancodeFormRef)">保存</el-button>
                        <span class="text-gray-900 text-sm">※JANCODE関連設定保存</span>
                    </div>
                </div>
            </div>
        </el-mian>
    </el-container>
</template>

<script lang="ts">
import axios from 'axios';
import { ElMessage, FormInstance, FormRules } from 'element-plus';
import { Minus } from '@element-plus/icons-vue'
import { defineComponent, ref, onMounted, watch } from 'vue';

interface JancodeInfo {
    appid: string,
    count?: number;
}

type JancodeSettings = {
    [key: string]: string;  // 所有属性的值都是字符串
};

type JancodeCount = {
    [key: string]: number;
};

export default defineComponent({
    name: 'MngSettings',
    components: {
        Minus,
    },
    setup(props, ctx) {
        
        const loading1 = ref(false);
        const loading2 = ref(false);
        const loading3 = ref(false);
        const loading4 = ref(false);

        // メール設定
        const emailSettings = ref({
            emailAccount: '',
            emailPassword: '',
            emailServerUrl: '',
            emailServerPort: '',
            emailSender: '',
            emailSubject: '',
            emailText: '',
        });

        // アラート設定
        const notificationSettings = ref({
            notificationSubject: '',
            notificationText: '',
        });

        const showJancodeSettings = ref([true, false, false, false, false, false, false, false, false, false]);

        // JANCODE設定
        const jancodeSettings = ref<JancodeSettings>({
            appid0: '',
            appid1: '',
            appid2: '',
            appid3: '',
            appid4: '',
            appid5: '',
            appid6: '',
            appid7: '',
            appid8: '',
            appid9: '',
        });
        const jancodeCount = ref<JancodeCount>({
            count0: 0,
            count1: 0,
            count2: 0,
            count3: 0,
            count4: 0,
            count5: 0,
            count6: 0,
            count7: 0,
            count8: 0,
            count9: 0,
        });

        const emailRules: FormRules = {
            emailAccount: [
                { required: true, message: 'メールアカウントを入力してください', trigger: ['blur', 'change'] },
                {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: '有効なメールアドレスを入力してください',
                    trigger: ['blur', 'change']
                }
            ],
            emailPassword: [
                { required: true, message: 'メールパスワードを入力してください', trigger: ['blur', 'change'] }
            ],
            emailServerUrl: [
                { required: true, message: 'メールサーバーURLを入力してください', trigger: ['blur', 'change'] },
                { min: 2, max: 50, message: 'メールサーバーURLは2〜50文字の間で入力してください', trigger: ['blur', 'change'] }
            ],
            emailServerPort: [
                { required: true, message: 'ポートを入力してください', trigger: ['blur', 'change'] },
                {
                    validator: (rule, value, callback) => {
                        const port = parseInt(value);
                        if (isNaN(port) || port < 1 || port > 65535) {
                            callback(new Error('ポートは1〜65535の間で入力してください'));
                        } else {
                            callback();
                        }
                    },
                    trigger: ['blur', 'change']
                }
            ],
            emailSender: [
                { required: true, message: '送信者を入力してください', trigger: 'blur' },
                {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: '有効なメールアドレスを入力してください',
                    trigger: ['blur', 'change']
                }
            ],
            emailSubject: [
                { required: true, message: 'タイトルを入力してください', trigger: ['blur', 'change'] }
            ],
            emailText: [
                { required: true, message: '内容を入力してください', trigger: ['blur', 'change'] }
            ],
        };

        const notificationRules: FormRules = {
            notificationSubject: [
                { required: true, message: 'タイトルを入力してください', trigger: ['blur', 'change'] }
            ],
            notificationText: [
                { required: true, message: '内容を入力してください', trigger: ['blur', 'change'] }
            ],
        };

        const jancodeRules: FormRules = {
            appid0: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid1: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid2: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid3: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid4: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid5: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid6: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid7: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid8: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
            appid9: [
                { required: true, message: 'AppIdを入力してください', trigger: ['blur', 'change'] }
            ],
        };

        const emailFormRef = ref<FormInstance>();

        const notificationFormRef = ref<FormInstance>();

        const jancodeFormRef = ref<FormInstance>();

        // 定期タスク時間
        // const cronForm = ref({
        //     cronTime: '30 15 * * *'
        // });

        // const cronFormRef = ref<FormInstance>();

        // const cronRules: FormRules = {
        //     cronTime: [
        //         { required: true, message: '定期タスク時間を入力してください', trigger: 'blur' },
        //         {
        //             pattern: /^(\*|([0-9]|[1-5][0-9])) (\*|([0-9]|1[0-9]|2[0-3])) (\*|([1-9]|[12][0-9]|3[01])) (\*|([1-9]|1[0-2])) (\*|([0-6]))$/,
        //             message: '正しい定期タスク時間形式を入力してください（例：30 15 * * *）',
        //             trigger: 'blur'
        //         }
        //     ]
        // };


        /**
         * 挂载
         */
        onMounted(async () => {
            // await getCronTime();
            await getEmailSettings();
            await getNotificationSettings();
            await getJancodeSettings();
        });


        /**
         * 触发定期処理
         */
        const handleTaskButton = async () => {
            await trickProcess().then((res) => {
                ElMessage.info("定期処理成功");
            }).catch((err) => {
                ElMessage.error("定期処理失敗");
            });
        }


        /**
         * 触发定期処理
         */
        const trickProcess = async () => {
            await axios.get('/api/settings/tricks').then((res) => {
                return res;
            }).catch((err) => {
                throw err;
            });
        };


        /**
         * 获取邮件设置
         */
        const getEmailSettings = async () => {
            try {
                loading1.value = true;   
                const res = await axios.get('/api/settings/email');
                const { data } = res.data;
                emailSettings.value = JSON.parse(data);
            } catch (err) {
                ElMessage.error('メール設定の取得が失敗しました');
            } finally {
                loading1.value = false;
            }
        }

        /**
         * 获取邮件设置
         */
         const getNotificationSettings = async () => {
            try {
                loading2.value = true;
                const res = await axios.get('/api/settings/notification');
                const { data } = res.data;
                notificationSettings.value = JSON.parse(data);
            } catch (err) {
                ElMessage.error('アラート設定の取得が失敗しました');
            } finally {
                loading2.value = false;
            }
        }

        /**
         * 获取JANCODE设置
         */
         const getJancodeSettings = async () => {
            try {
                loading4.value = true;
                const res = await axios.get('/api/settings/jancode');
                const { data } = res.data;
                const jancodeSettingsInfo: JancodeInfo[] = JSON.parse(data);

                jancodeSettingsInfo.forEach((item, i) => {
                    jancodeSettings.value[`appid${i}`] = item.appid;
                    showJancodeSettings.value[i] = true;
                    jancodeCount.value[`count${i}`] = item.count ?? 0;
                });
            } catch (err) {
                ElMessage.error('JANCODE設定の取得が失敗しましgetJancodeSettingsた');
            } finally {
                loading4.value = false;
            }
        }
        
        /**
         * 获取定期処理时间
         */
        // const getCronTime = async () => {
        //     try {
        //         loading3.value = true;
        //         const res = await axios.get('/api/settings/crontime');
        //         const { data } = res.data;
        //         cronForm.value.cronTime = data;
        //     } catch (err) {
        //         ElMessage.error('定期タスクの取得が失敗しました');
        //     } finally {
        //         loading3.value = false;
        //     }
        // }


        /**
         * メール設定保存
         */
        const handleSaveEmailButton = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const res = await axios.post('/api/settings/email', emailSettings.value);
                        if (res.data.code === 0) {
                            ElMessage.success('メール設定の保存が成功しました');
                        } else {
                            ElMessage.error('メール設定の保存が失敗しました');
                        }
                    } catch (err) {
                        ElMessage.error('メール設定の保存が失敗しました');
                    }
                }
            })
        }

        /**
         * アラート設定保存
         */
         const handleSaveNotificationButton = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const res = await axios.post('/api/settings/notification', notificationSettings.value);
                        if (res.data.code === 0) {
                            ElMessage.success('アラート設定の保存が成功しました');
                        } else {
                            ElMessage.error('アラート設定の保存が失敗しました');
                        }
                    } catch (err) {
                        ElMessage.error('アラート設定の保存が失敗しました');
                    }
                }
            })
        }

        const handleAddJancodeButton = () => {
            const index = showJancodeSettings.value.findIndex(value => value === false);
            if (index !== -1) {
                showJancodeSettings.value[index] = true; // 找到第一个 false 后将其改为 true
                jancodeCount.value[index] = 0; // 初始化计数为 0
            }
        }

        const handleDelJancodeButton = (index: number) => {
            if (index >= 0 && index < showJancodeSettings.value.length) {
                // 将 showJancodeSettings 中的元素移到最后
                showJancodeSettings.value.splice(index, 1)[0];  // 移除元素
                showJancodeSettings.value.push(false);

                // 更新 jancodeSettings：将对应的数据从 appidX 向前移动
                for (let i = index + 1; i < showJancodeSettings.value.length + 1; i++) {
                    const currentAppidKey = `appid${i}`;
                    const previousAppidKey = `appid${i - 1}`;

                    // 将 appidX 数据移动到 appidX-1 的位置
                    jancodeSettings.value[previousAppidKey] = jancodeSettings.value[currentAppidKey];
                    delete jancodeSettings.value[currentAppidKey]; // 删除原位置的键值对


                    const currentCountKey = `count${i}`;
                    const previousCountKey = `count${i - 1}`;

                    // 将 countX 数据移动到 countX-1 的位置
                    jancodeCount.value[previousCountKey] = jancodeCount.value[currentCountKey];
                    delete jancodeCount.value[currentCountKey]; // 删除原位置的键值对
                }
            }
        }

        /**
         * JANCODE設定保存
         */
         const handleSaveJancodeButton = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const appids = Object.entries(jancodeSettings.value)
                            .filter(([key, value]) => value !== '' && value !== null && value !== undefined)  // 筛选出非空的值
                            .map(([key, value]) => value);  // 提取值并存入新数组

                        const res = await axios.post('/api/settings/jancode', appids);
                        if (res.data.code === 0) {
                            getJancodeSettings();
                            ElMessage.success('JANCODE設定の保存が成功しました');
                        } else {
                            ElMessage.error('JANCODE設定の保存が失敗しました');
                        }
                    } catch (err) {
                        ElMessage.error('JANCODE設定の保存が失敗しました');
                    }
                }
            })
        }

        /**
         * 定期タスク設定保存
         */
        // const handleSaveCronTimeButton = async (formEl: FormInstance | undefined) => {
        //     if (!formEl) return
        //     await formEl.validate(async (valid, fields) => {
        //         if (valid) {
        //             try {
        //                 const res = await axios.post('/api/settings/crontime', {
        //                     cronTime: cronForm.value.cronTime
        //                 });
        //                 if (res.data.code === 0) {
        //                     ElMessage.success('定期タスクの更新が成功しました');
        //                 } else {
        //                     ElMessage.error('定期タスクの更新が失敗しました');
        //                 }
        //             } catch (error) {
        //                 ElMessage.error('定期タスクの更新が失敗しました');
        //             }
        //         }
        //     })
        // }



        return {
            emailSettings,
            notificationSettings,
            jancodeSettings,
            jancodeCount,
            emailRules,
            notificationRules,
            emailFormRef,
            notificationFormRef,
            jancodeRules,
            jancodeFormRef,
            // cronForm,
            // cronRules,
            // cronFormRef,
            loading1,
            loading2,
            loading3,
            loading4,
            handleSaveEmailButton,
            handleSaveNotificationButton,
            // handleSaveCronTimeButton,
            showJancodeSettings,
            handleSaveJancodeButton,
            handleDelJancodeButton,
            handleAddJancodeButton,
            handleTaskButton
        }
    }
});
</script>
